import { render, staticRenderFns } from "./Pharmacy.vue?vue&type=template&id=1622ab50&scoped=true"
import script from "./Pharmacy.vue?vue&type=script&lang=js"
export * from "./Pharmacy.vue?vue&type=script&lang=js"
import style0 from "./Pharmacy.vue?vue&type=style&index=0&id=1622ab50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1622ab50",
  null
  
)

export default component.exports